/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {TSErfassungsArt} from '../../../models/enums/TSErfassungsArt';
import {TSRechtsform} from '../../../models/enums/TSRechtsform';
import {TSSchadenObjektTyp} from '../../../models/enums/TSSchadenObjekt';
import TSSchaden from '../../../models/TSSchaden';
import TSSchadenDaten from '../../../models/TSSchadenDaten';
import TSSchadenfall from '../../../models/TSSchadenfall';
import DVBernUtil from '../../../utils/DVBernUtil';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./schadenView.scss');
let template = require('./schadenView.html');

export class SchadenEditViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = SchadenViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schaden: '<',
        readonly: '<',
        schadenfall: '<',
        mehrSchadenAnsicht: '<',
    };
}

export class SchadenViewController {

    schaden: TSSchaden;
    form: IFormController;
    schadenfall: TSSchadenfall;
    schadenfallId: string;
    doctype: TSDocumentType = TSDocumentType.SCHADEN_DOC;
    mehrSchadenAnsicht: string;

    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state', 'AuthServiceRS', 'RoleUtilService'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService,
                private $log: ILogService,
                private $state: IStateService,
                private authServiceRS: AuthServiceRS,
                private roleUtilService: RoleUtilService,
    ) {

    }

    $onInit() {
        if (this.schadenfall) {
            this.schadenfallId = this.schadenfall.id;
            this.$log.debug('Edit or createOrUpdate Schaden on Schadenfall ' + this.schadenfallId);
        } else {
            this.$log.error('No schadenfall!');
        }

        if (!this.schaden) {
            this.schaden = new TSSchaden();
            this.schaden.schadenDatenFS = new TSSchadenDaten();
            this.$log.warn('initialized schaden to edit directly in view, should pass schaden to edit along');
        }

    }

    public goBack() {
        this.$state.go('schadenmeldung', {schadenfallId: this.schadenfallId})
    }

    public showGeschaetztekosten(): boolean {
        return (this.schadenfallModelManager.isStatusAfterNeu() || this.schadenfallModelManager.isStatusNeuPapierFS()) && this.isGeschaetzteKostenAvailable();
    }

    private isGeschaetzteKostenAvailable() {
        return !!(this.schaden && this.schaden.schadenDatenFS && this.schaden.schadenDatenFS.geschaetzteKosten);

    }

    public requiredGeschaetzteKostenAndMassnahmen(): boolean {
        return this.schadenfallModelManager.isStatusAbAuftragSchaetzer() || this.schadenfallModelManager.isStatusNeuPapierFS();
    }

    /***
     * spezialvalidierung fuer wald da hier 2 felder gleichzeitg fuer die validierung
     * betrachtet werden
     */
    public isWaldValid() {
        if (this.schaden.schadenDatenFS.schadenObjekt === TSSchadenObjektTyp.WALD) {
            let formschaden = this.form['vm.formschaden'];
            if (!this.schaden.schadenDatenFS.schadenObjektDaten.flaecheAre && !this.schaden.schadenDatenFS.schadenObjektDaten.holzMenge) {
                formschaden['waldvalidation'].$setValidity('wald', false);
                return false;
            } else {
                formschaden['waldvalidation'].$setValidity('wald', true);
            }

        }
        return true;
    }

    public isMehrSchadenAnsicht(): boolean {
        return this.mehrSchadenAnsicht === 'true';
    }

    public showZustimmungSteuerpruefung(): boolean {
        return !(this.schadenfall.erfassungsart === TSErfassungsArt.PAPIER);
    }

    public getZustimmungPruefungFondsuisseText(): string {
        if (this.isGenossenschaft()) {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT');
        } else {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE');
        }
    }

    private isGenossenschaft() {
        return this.schadenfall.gesuchsteller.rechtsform === TSRechtsform.GENOSSENSCHAFT;
    }

    public getZustimmungGesuchstellerReadonly(): boolean {
        return !this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles());
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/schadenView/schadenView.ts